<script>
import ElAlert from 'element-ui/lib/alert'

export default {
  name: 'ElAlert',
  extends: ElAlert,
  render (h) {
    const vnode = ElAlert.render.call(this, h)
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-alert']
    return vnode
  }
}
</script>
